// extracted by mini-css-extract-plugin
export default {"container":"ModalFooter_container__hpKtb","singleBtn":"ModalFooter_singleBtn__0mKAS"};